import { SETDETALLE } from './actionTypes';
//import IState from './state.model';
//import IAction from './action.model';
import IAction from '../../models/action.model';


const defaultStore: any = {
  //solicitudBean: {}
}


export default function solicitud(
  state: any = defaultStore,
  action: IAction,
) {
  switch (action.type) {
    case SETDETALLE: 
      return {
        ...state,
        ...action.payload //
      };

    default:
      return state;
  }
}
